import SwiperSlider from './SwiperSlider';

export default class SliderBusinessCases {
  init() {
    const blockSliderBusinessCaseList = Array.from(
      document.querySelectorAll('.slider-business-cases')
    );

    for (let blockSliderBusinessCase of blockSliderBusinessCaseList) {
      const gridVisual = blockSliderBusinessCase.classList.contains(
        'slider-business-cases--grid-visual'
      );

      const sliders = Array.from(
        blockSliderBusinessCase.querySelectorAll(
          '.slider-business-cases__swiper'
        )
      );

      for (let slider of sliders) {
        const slides = Array.from(slider.querySelectorAll('.swiper-slide'));

        const sliderConfig = {
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: false,
          slidesPerGroup: 1,
          slidesPerGroupAuto: true,
          navigation: {
            nextEl: blockSliderBusinessCase.querySelector(
              '.swiper-button-next'
            ),
            prevEl: blockSliderBusinessCase.querySelector(
              '.swiper-button-prev'
            ),
          },
          pagination: {
            el: blockSliderBusinessCase.querySelector('.swiper-pagination'),
            ...SwiperSlider.paginationConfig,
          },
          breakpoints: {},
        };

        if (slides.length > 4) {
          if (gridVisual) {
            sliderConfig.breakpoints[768] = {
              grid: {
                fill: 'row',
                rows: 2,
              },
            };
          }

          sliderConfig.breakpoints[1240] = {
            ...(sliderConfig.breakpoints[768] || {}),
            slidesPerGroup: slides.length > 6 ? 4 : 3,
          };
        } else {
          sliderConfig.breakpoints[1240] = {
            ...(sliderConfig.breakpoints[768] || {}),
            slidesPerGroup: 4,
          };
        }

        new SwiperSlider(slider, sliderConfig);
      }

      const navigationItems = Array.from(
        blockSliderBusinessCase.querySelectorAll(
          '.tabulation-navigation-slider__item'
        )
      );

      const sectors = Array.from(
        blockSliderBusinessCase.querySelectorAll(
          '.slider-business-cases__sector'
        )
      );

      for (let navigationItem of navigationItems) {
        const targetId = navigationItem.dataset.targetId;

        if (!targetId) {
          continue;
        }

        const targetSector = document.getElementById(targetId);

        if (!targetSector) {
          continue;
        }

        navigationItem.addEventListener('click', (e) => {
          e.preventDefault();

          for (let items of navigationItems) {
            items.classList.remove(
              'tabulation-navigation-slider__item--is-current'
            );
          }

          for (let sector of sectors) {
            sector.classList.remove(
              'slider-business-cases__sector--is-current'
            );
          }

          navigationItem.classList.add(
            'tabulation-navigation-slider__item--is-current'
          );

          targetSector.classList.add(
            'slider-business-cases__sector--is-current'
          );
        });
      }
    }
  }
}
